import { IconButton, Stack } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import NotificationMenu from '../../../components/notifications/NotificationMenu';
import UserMenuDropdown from './UserMenuDropdown';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/layout-icons/CalendarIcon.svg';
import { ReactComponent as MessageIcon } from '../../../assets/icons/layout-icons/MessageIcon.svg';

const RightSideToolbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const path = location.pathname;
  const isOnChatPage = path.includes('/dashboard/chat');

  const handleChatClick = () => {
    if (isOnChatPage) {
      // If already on chat page, navigate back to dashboard
      navigate('/dashboard');
    } else {
      // Otherwise, navigate to chat
      navigate('/dashboard/chat');
    }
  };

  return (
    <Stack spacing="15px" direction="row" sx={{ pr: path.includes('dashboard') ? '24px' : 0 }}>
      <IconButton
        className="react-joyride-step-2"
        size="large"
        sx={{
          border: '1px solid #BFC6D7',
        }}
        onClick={() => navigate('/dashboard/chat')}
      >
        <MessageIcon fill="#79829B" />
      </IconButton>

      <IconButton
        className="react-joyride-step-3"
        size="large"
        sx={{
          border: '1px solid #BFC6D7',
        }}
        onClick={() => navigate('/dashboard/calendar')}
      >
        <CalendarIcon fill="#79829B" />
      </IconButton>

      <NotificationMenu />
      <UserMenuDropdown />
    </Stack>
  );
};
export default RightSideToolbar;
